import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const Header = styled.div`
  align-items: center;
  background: white;
  display: flex;
  gap: 1rem;
  justify-content: space-between;
  width: 100%;

  .input {
    flex: 1;

    input {
      margin: 0;
    }
  }
`;

export const GridContent = styled.div`
  box-sizing: border-box;
  display: grid;
  gap: 1rem;
  grid-template-columns: repeat(auto-fill, minmax(8.5rem, 1fr));
  grid-template-rows: 0fr 0fr;
  justify-items: center;
  min-height: 60svh;
  width: 100%;

  label {
    min-height: unset;
    padding: unset;

    input {
      float: unset !important;
      margin: unset !important;
    }
  }
`;

export const FlexContent = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  min-height: 60svh;
`;

export const BlankStateContainer = styled.div`
  ${({ theme: { colors, fontSizes } }) => css`
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-height: 60svh;
    width: 100%;

    p {
      color: ${colors.brandDark};
      font-size: ${fontSizes.s16};
      margin: 0;
    }
  `}
`;

export const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
`;

export const ConnectYoutube = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 1rem 0;
  width: 100%;
`;
